module.exports = __webpack_public_path__ + "static/img/pos-img.27fc209.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pos-img.png
// module id = sn+2
// module chunks = 1